// extracted by mini-css-extract-plugin
export default {"SendBackModal__container":"MqW6vV4MsM"};